import { ENV_VARS } from '@utils/getEnvVar';
import globalWindow from '@utils/globals';
import { InboundIframeMessage } from './types';

const { document, location } = globalWindow;

const isDevelopment = ENV_VARS.env === 'development';

export const getTargetOrigin = () => {
  if (isDevelopment) {
    if (document && location && typeof URL !== 'undefined') {
      const url = new URL(ENV_VARS.previewTargetOrigin || `${location.protocol}//${document.domain}`);
      if (!url.port) {
        url.port = location.port;
      }
      return url.origin;
    }
  }
  return `https://${document?.domain}`;
};

export const getPostMessageTarget = () => {
  return isDevelopment ? '*' : getTargetOrigin();
};

const acceptedOriginsList = [getTargetOrigin(), ...(isDevelopment ? ['http://localhost:3000'] : [])].filter(x => x);
const ACCEPTED_ORIGINS = new Set(acceptedOriginsList);
const isValidRequestOrigin = (origin: string) => {
  return ACCEPTED_ORIGINS.has(origin);
};

export const createIframeMessageEventHandler = (cb: (message: InboundIframeMessage, ev: MessageEvent) => void) => (
  msgEvent: MessageEvent
) => {
  if (!isValidRequestOrigin(msgEvent.origin)) {
    return;
  }

  if (msgEvent.data) {
    try {
      const message: InboundIframeMessage = typeof msgEvent.data === 'object' ? msgEvent.data : JSON.parse(msgEvent.data);
      if (message?.source === 'joyPreview') {
        cb(message, msgEvent);
      }
    } catch (e) {
      console.error(msgEvent.data, e);
    }
  }
};
